import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AllowedFileTypeService {
  public static readonly allowedFileTypesForFileUpload = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
}
